<app-categories-table categoryType="Item" />
